<template>
  <div>
    <div class="item" @click="gotoBargain">
      <div class="image-wrap">
        <img :src="item.activity_pic" />
        <div class="tag" v-if="setting.inventory && item.can_purchase > 0">剩余 {{ item.can_purchase }}</div>
        <div class="tag end" v-if="setting.inventory && item.can_purchase <= 0">已售罄</div>
      </div>
      <div class="info">
        <div class="name">{{ item.activity_name }}</div>
        <div class="price" v-if="setting.bargain_word">
          <div class="pass">
            <span>已砍</span>
            <span class="num">{{ item.help_money }}</span>
            <span>元</span>
          </div>
          <div class="residue">
            <span>还差</span>
            <span class="num">{{ item.surplus_money }}</span>
            <span>元</span>
          </div>
        </div>
        <div class="bar" v-if="setting.progress_bar">
          <div class="bar-all" :style="{ background: colorFirst }"></div>
          <div class="bar-end" :style="[{ background: colorFirst },{ width: item.help_bfb + '%' }]"></div>
          <div class="bar-text">{{ item.help_bfb }}%</div>
        </div>
        <div class="bargaining-count" v-if="!clearTimer && setting.count_down">
          <div class="text">剩余</div>
          <div class="count-down">
            <div class="num hour">{{ hour }}</div>
            <div class="letter">:</div>
            <div class="num minute">{{ minute }}</div>
            <div class="letter">:</div>
            <div class="num second">{{ second }}</div>
          </div>
          <div class="text">结束</div>
        </div>
        <div class="end-text" v-if="clearTimer">该商品砍价失败</div>
        <div
          class="continue"
          :style="{ background: colorFirst }"
          v-if="!clearTimer && item.can_purchase > 0"
        >
        {{item.is_success == 1 ? "去查看":"继续砍"}}
        </div>
        <div class="bargain-end-btn" v-if="clearTimer && item.can_purchase > 0">已结束</div>
        <div class="bargain-end-btn" v-if="!clearTimer && item.can_purchase <= 0">已售罄</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BargainingItem",
  props: {
    item: Object,
    colorFirst: String,
    setting: Object
  },
  data() {
    return {
      day: "00",
      hour: "00",
      minute: "00",
      second: "00",
      clearTimer: false // 倒计时是否停止
    };
  },
  components: {},
  mounted() {
    this.getLastTime();
  },
  methods: {
    gotoBargain() {
      this.$emit("gotoBargain");
    },
    // 倒计时
    init() {
      const self = this;
      setTimeout(function() {
        self.getLastTime.call(self);
      }, 1000);
    },
    getLastTime() {
      let time = this.item.count_down;
      const gapTime = Math.ceil((time - new Date().getTime()) / 1000);
      let day = "00";
      let hour = "00";
      let minute = "00";
      let second = "00";
      if (gapTime > 0) {
        day = this.formatNum(parseInt(gapTime / 86400));
        // let lastTime = gapTime % 86400; // 不需要天
        let lastTime = gapTime;
        hour = this.formatNum(parseInt(lastTime / 3600));
        lastTime = lastTime % 3600;
        minute = this.formatNum(parseInt(lastTime / 60));
        second = this.formatNum(lastTime % 60);
        if (!this.clearTimer) this.init.call(this);
      } else {
        this.endfn();
      }
      this.day = day;
      this.hour = hour;
      this.minute = minute;
      this.second = second;
    },
    // 本场砍价倒计时结束回调
    endfn() {
      this.clearTimer = true;
    },
    // 倒计时时间格式化
    formatNum(num) {
      return num > 9 ? num : `0${num}`;
    }
  }
};
</script>

<style scoped lang="scss">
.item {
  padding: 0.3rem 0.2rem;
  height: 2.2rem;
  background: #ffffff;
  border-bottom: 1px solid #ededed;
  display: flex;
}
.item:last-child {
  border-bottom: none;
}
.image-wrap {
  position: relative;
  flex: 0 0 2.2rem;
  width: 2.2rem;
  margin-right: 0.42rem;
}
.image-wrap > img {
  display: block;
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 0.06rem;
  border-radius: .12rem;
}
.image-wrap .tag {
  position: absolute;
  top: 0.15rem;
  left: -0.2rem;
  z-index: 99;
  padding: 0 0.11rem;
  height: 0.3rem;
  font-size: 0.22rem;
  line-height: 0.3rem;
  border-radius: 0 0.2rem 0.2rem 0;
  color: #ffffff;
  background: linear-gradient(
    90deg,
    rgba(255, 77, 29, 1),
    rgba(251, 123, 0, 1)
  );
  &.end {
    background: #eee;
    color: #888;
  }
}
.info {
  position: relative;
  flex: 1;
}
.name {
  position: absolute;
  left: 0;
  top: 0.11rem;
  font-size: 0.3rem;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.price {
  position: absolute;
  left: 0;
  top: 0.36rem;
  display: flex;
  font-size: 0.24rem;
  color: #888888;
  margin: 0.2rem 0 0.24rem;
}
.price .pass {
  margin-right: 0.2rem;
}
.price .num {
  color: #e51722;
  font-size: 0.28rem;
  font-weight: 500;
}
.bar {
  position: absolute;
  top: 1.2rem;
  left: 0;
  width: 2rem;
  height: 0.25rem;
  border-radius: 0.13rem;
  overflow: hidden;
  .bar-all {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 34, 23, 1);
    opacity: 0.5;
  }
  .bar-end {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background: rgba(255, 34, 23, 1);
    z-index: 99;
    border-radius: 0.13rem;
  }
  .bar-text {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    text-align: center;
    line-height: 0.18rem;
    font-size: 0.18rem;
    z-index: 100;
    color: #ffffff;
    transform: translateY(-50%)
  }
}
.bargaining-count {
  position: absolute;
  left: 0;
  bottom: 0.1rem;
  display: flex;
  align-items: center;
  line-height: 0.3rem;
  > .text {
    color: #888888;
    font-size: 0.22rem;
  }
  .count-down {
    margin: 0 4px;
    display: flex;
    color: #222222;
    font-size: 0.24rem;
    align-items: center;
    .num {
      width: 0.32rem;
      height: 0.3rem;
      line-height: 0.3rem;
      text-align: center;
      font-size: 0.22rem;
      color: #ffffff;
      background: #111111;
      border-radius: 0.05rem;
    }
    .letter {
      margin: 0 0.02rem;
    }
  }
}
.continue,
.bargain-end-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 1.4rem;
  height: 0.6rem;
  text-align: center;
  background: rgba(255, 46, 31, 1);
  border-radius: 0.05rem;
  font-size: 0.28rem;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.end-text {
  position: absolute;
  left: 0;
  bottom: 0.1rem;
  color: #888888;
  font-size: 0.22rem;
}
.bargain-end-btn {
  background: rgba(238, 238, 238, 1);
  color: #888;
}
</style>



// WEBPACK FOOTER //
// src/pages/Bargain/components/BargainingItem.vue